module.exports = __webpack_public_path__ + "cfdd4e534e49679b85190c405f2e1dbf.svg";